
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment/withdraw",
      function () {
        return require("private-next-pages/payment/withdraw/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment/withdraw"])
      });
    }
  